export const VehicleEmissionStandard = {
    List: [
        {value: "01", label: "VMS_REQUEST_VISITOR_VEHICLE_EMISSION_STANDARD_NATIONAL_III"},
        {value: "02", label: "VMS_REQUEST_VISITOR_VEHICLE_EMISSION_STANDARD_NATIONAL_IV"},
        {value: "03", label: "VMS_REQUEST_VISITOR_VEHICLE_EMISSION_STANDARD_NATIONAL_V"},
        {value: "04", label: "VMS_REQUEST_VISITOR_VEHICLE_EMISSION_STANDARD_NATIONAL_VI"},
        {value: "05", label: "VMS_REQUEST_VISITOR_VEHICLE_EMISSION_STANDARD_NATIONAL_ELECTRIC"},
    ],
    Map: new Map<string, string>([
        ['01', 'VMS_REQUEST_VISITOR_VEHICLE_EMISSION_STANDARD_NATIONAL_III'],
        ['02', 'VMS_REQUEST_VISITOR_VEHICLE_EMISSION_STANDARD_NATIONAL_IV'],
        ['03', 'VMS_REQUEST_VISITOR_VEHICLE_EMISSION_STANDARD_NATIONAL_V'],
        ['04', 'VMS_REQUEST_VISITOR_VEHICLE_EMISSION_STANDARD_NATIONAL_VI'],
        ['05', 'VMS_REQUEST_VISITOR_VEHICLE_EMISSION_STANDARD_NATIONAL_ELECTRIC'],
    ]),
    Enum: {
        National_III: '01',
        National_IV: "02",
        National_V: '03',
        National_VI: '04',
        Electric: '05',
    }
};